import Toast from "../../component/toastify/Index";
import axios from "../../axios/interceptor";

export const getAdminProfileDetails = async () => {
    try {
        const response = await axios.get('/superAdmin/profile/getSuperAdminProfile')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateAdminProfileDetails = async (payload) => {
    try {
        const response = await axios.put('/superAdmin/profile/updateSuperAdminProfile', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateAdminLanguage = async (payload) => {
    try {
        const response = await axios.put('/superAdmin/profile/updateSuperAdminLanguage', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateAdminPassword = async (payload) => {
    try {
        const response = await axios.put('/superAdmin/profile/changeAdminProfilePassword', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}